const openCloseAccordion = ($item, breakpoint) => {
  try {
    let current_breakpoint = window.theme.breakpoints.current;
    const $accordion = $item.closest('.accordion');

    if (current_breakpoint !== 'mobile') {
      current_breakpoint = 'desktop';
    }

    if (!$accordion.find(`[data-${breakpoint}-accordion]`).length || current_breakpoint !== breakpoint) {
      return false;
    }

    let is_active = $item.hasClass('active');
    const is_active_on_load = $item.hasClass('active-on-load');
    const $content = $item.find('[data-accordion-content]');
  
    $accordion.find(`[data-${breakpoint}-accordion]`).removeClass('active').removeClass('active-on-load');
  
    if (is_active_on_load) {
      is_active = false;
    }
  
    if (!is_active) {
      $item.addClass('active');
      $content.css('max-height', $content[0].scrollHeight);
    }
  
    $accordion.find(`[data-${breakpoint}-accordion]:not(.active) [data-accordion-content]`).css('max-height', 0);
  
    // [ADA] Update aria attributes for all items
    $accordion.find(`[data-${breakpoint}-accordion]`).each(function () {
      const $accordionItem = $(this);
      const $accordionTitle = $accordionItem.find('[data-accordion-title]');
      const $accordionContent = $accordionItem.find('[data-accordion-content]');
      const isActive = $accordionItem.hasClass('active');
    
      $accordionTitle.attr('aria-expanded', isActive).attr('role', 'button');
      $accordionContent.attr('aria-hidden', !isActive).attr('role', 'region').attr('aria-labelledby', $accordionTitle.attr('id'));
    });

    $(window).trigger('resize');
    /*
    // pdp template v2, refresh every 1ms for 200ms
    const scroll_interval = window.setInterval(() => {
      $(window).trigger('scroll');
    }, 1);
  
    window.setTimeout(() => {
      window.clearInterval(scroll_interval);
    }, 200);
    */
  } catch (e) {
    console.log(e);
  }

  return true;
};

/*
const resetAccordion = (accordion_item = '') => {
  const parent_element = (accordion_item === '') ? '' : `${accordion_item} `;

  if (window.theme.breakpoints.current === 'mobile') {
    $(`${parent_element}[data-desktop-accordion]`).removeClass('active');
    $(`${parent_element}[data-desktop-accordion] [data-accordion-content]`).removeAttr('style');
    if ($(`${accordion_item}.has-accordion .accordion [data-mobile-accordion]`).length) {
      $(`${accordion_item}.has-accordion .accordion [data-mobile-accordion]`).first().addClass('active-on-load');
    }
    if ($(`${accordion_item}.has-accordion .accordion [data-desktop-accordion]`).length) {
      $(`${accordion_item}.has-accordion .accordion [data-desktop-accordion]`).first().addClass('active-on-load');
    }
    if ($(`${parent_element}[data-mobile-accordion].active-on-load`).length) {
      $(`${parent_element}[data-mobile-accordion].active-on-load`).trigger('click');
    }
  } else {
    $(`${parent_element}[data-mobile-accordion]`).removeClass('active');
    $(`${parent_element}[data-mobile-accordion] [data-accordion-content]`).removeAttr('style');
    $(`${parent_element}.has-accordion .accordion [data-mobile-accordion]`).first().addClass('active-on-load');
    $(`${parent_element}.has-accordion .accordion [data-desktop-accordion]`).first().addClass('active-on-load');
    $(`${parent_element}[data-desktop-accordion].active-on-load`).trigger('click');
  }
};
*/

// Content height can change when resizing the browser
const updateActiveHeight = (accordion_item = '') => {
  const parent_element = (accordion_item === '') ? '' : `${accordion_item} `;
  const $active_item = $(`${parent_element} .active`);

  if (!$active_item.length) {
    return;
  }

  const $content = $active_item.find('[data-accordion-content]');
  $content.css('max-height', $content[0].scrollHeight);
};

const initAccordion = (accordion_item = '') => {
  const parent_element = (accordion_item === '') ? '' : `${accordion_item} `;

  // [ADA]
  if ($(`${parent_element}[data-desktop-accordion] [data-accordion-content]`).length) {
    $(`${parent_element}[data-desktop-accordion] [data-accordion-content]`).attr('tabindex', 0);
  }

  $(document).on('click touchend', `${accordion_item}.has-accordion .accordion [data-mobile-accordion] [data-accordion-title]`, (e) => {
    if (window.theme.breakpoints.current !== 'mobile') {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const $item = $(e.currentTarget);
    openCloseAccordion($item.parent(), 'mobile');
  });

  $(document).on('click keydown', `${accordion_item}.has-accordion .accordion [data-desktop-accordion] [data-accordion-title]`, (e) => {
    // Handle both click and keyboard events
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }

    if (window.theme.breakpoints.current === 'mobile') {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    
    const $item = $(e.currentTarget);
    openCloseAccordion($item.parent(), 'desktop');
  });

  // [ADA]
  /*$(document).on('keypress', `${accordion_item}.has-accordion .accordion [data-desktop-accordion] [data-accordion-title]`, (e) => {
    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });*/

  $(window).on('resize', _.debounce(() => {
    updateActiveHeight(accordion_item);
  }, 100));

  // Open the "Active on Load" item(s) if defined
  if ($(`${parent_element} .accordion__item.active-on-load`).length) {
    $(`${parent_element} .accordion__item.active-on-load [data-accordion-title]`).trigger('click');
  }
};

export {
  initAccordion,
  // resetAccordion,
};
